import { atom } from "jotai";

import { AddPeopleSearch_Atom } from "@/features/AddPatrons/atoms/stores";

import { currentModalStepAtom } from "../../stores";

export const enterSwapPlayersBetweenGroupsStepAtom = atom(
  null,
  (_get, set, payload: { roundId: string }) => {
    set(AddPeopleSearch_Atom, "");
    set(currentModalStepAtom, {
      type: "SwapPlayersPrivate",
      roundId: payload.roundId,
    });
  }
);
